export const MetabolicProfileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="18"
    viewBox="0 0 23 17"
    fill="none"
  >
    <path
      d="M0.620605 10.4425H4.97675L7.40756 3L9.43696 10.4425H14.1871L16.7071 15L19.2271 10.4425H22.6206"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
)
